import { Button, TextInput } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import "./forgotPassword.css";
import LoginUiComponent from "../../components/loginUiComponent/loginUiComponent";
import { getLob, getLoginPolicyandTwoFactorAuthState, getLoginUIConfig, sendForgotPasswordOtpAddress } from "../../services/authenticationService";
import { useLocation, useNavigate } from "react-router-dom";
import { openPopup } from "../../stateManagement/actions/popupActions";
import ToogleButton from "../../components/ToogleButton/ToogleButton";
import { getContactAddressType } from "../../services/authenticationService";
import { validDateEmail,validDateMobile } from "../../utils/utils";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { Loader } from "../../components/loader/Loader";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function ForgotPassword() {
  const CUR_COMPONENT = "LogInAndChangePassword"
  const { translate } = usePortalTranslation();
  const [loader , setLoader] = useState<boolean>(true);
  const [loginUIConfig, setLoginUIConfig] = useState(null);
  const contactAddressInput = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [toggleState, setToggleState] = useState<boolean>(false);
  const [contactAddressType, setcontactAddressType] = useState("sms");
  const [lob, setlob] = useState("");
  const [twoFactorContactType, setTwoFactorContactType] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  type stateData = {
    contactAddress: string;
    contactAddressType: string;
    twoFactorContactType: string | null;
  }
  const sendOtp = async () => {
    setToggleState(!toggleState);
    const contactAddress: string = contactAddressInput.current?.value!;

    if (twoFactorContactType && contactAddress.trim().length === 0) {
      openPopup("Error", `Please enter valid ${twoFactorContactType}`);
      setToggleState(false);
      return;
    }
    if (!twoFactorContactType && contactAddressType === "email" && !validDateEmail(contactAddress)) {
      openPopup("Error", "Please Enter Valid Email ID");
      setToggleState(false);
      return;
    } else if (!twoFactorContactType && contactAddressType === "sms" && !validDateMobile(contactAddress)) {
      openPopup("Error", "Please Enter Valid Phone Number");
      setToggleState(false);
    }
    if (contactAddress && lob) {
      try {
        localStorage.setItem("lob", lob);
        const response = await sendForgotPasswordOtpAddress(
          contactAddress,
          contactAddressType,
          twoFactorContactType
        );
        const responseId = response?.response?.id;
        if (response?.response?.statusCode === 200) {
          return navigate("/dashboardLogin/verifyOtp", {
            state: {
              contactAddress,
              contactAddressType,
              twoFactorContactType,
              responseId
            }
          } as { state: stateData });
        } else {
          openPopup("Error", "Please retry after sometime");
        }
      } catch (error) {
        openPopup(
          "Error",
          `Entered ${twoFactorContactType ?? (contactAddressType === "sms" ? "mobile number" : "email")} is not registered with us. Please contact support for assistance!`
        );
      }
    } else {
      openPopup(
        "Alert",
        contactAddress ? "Please Enter lob" : "Please Enter contact number"
      );
    }
    setToggleState(false);
  };
  async function callContactAddressType() {
    try {
      const { contactAddressType, contactType: ct } = await getContactAddressType();
      setcontactAddressType(contactAddressType);
      setTwoFactorContactType(ct);
    } catch (error) {
      setcontactAddressType("sms");
    } finally {
      setLoading(false);
    }
  }
  function extractLobFromURL() {
    const LOB = getLob();
    setlob(LOB);
  }
  useEffect(() => {
    extractLobFromURL();
    callContactAddressType();
  }, []);

  useEffect(() => {
    const fetchLoginPolicy = async () => {
      try {
        setLoader(true);
        const { loginUIConfig } = await getLoginUIConfig();
        setLoginUIConfig(loginUIConfig);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.error('Error fetching login policy:', error);
      }
    };
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    if (mediaQuery.matches) {
      setLoader(true);
      fetchLoginPolicy();
    }else{
      setLoader(true);
      setLoginUIConfig(null);
      setLoader(false);
    }
    const handleResize = async() => {
      if (mediaQuery.matches) {
        setLoader(true);
        await fetchLoginPolicy();
      }else{
        setLoader(true);
        setLoginUIConfig(null);
        setLoader(false);
      }
    };
    mediaQuery.addEventListener('change', handleResize);
    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);
  return (
    <>
    {
      loader ? <Loader /> :  <LoginUiComponent loginUIConfig={loginUIConfig}>
      {
        loading
          ?
          <Loader />
          :
          <form className="loginInputs">
            <TextInput
              sx={{ width: "70%", marginTop: "5%", borderRadius: "7rem" }}
              id="contactNumber"
              placeholder={
                twoFactorContactType ? `Enter ${twoFactorContactType}` :
                  contactAddressType === "sms"
                    ? translate(TranslationEnum.login_and_change_password,"Enter Phone Number")
                    : translate(TranslationEnum.login_and_change_password,"Enter Email Address")
              }
              type={twoFactorContactType ? "text" : contactAddressType === "sms" ? "number" : "email"}
              ref={contactAddressInput}
            />
            <ToogleButton
              loginUIConfig={loginUIConfig}
              status1="SEND OTP"
              status2="SENDING"
              handleChange={sendOtp}
              updateToggleState={toggleState}
              className="login-toggle-unchecked-icon-status-translation"
            />
            <div className="forgot-password-back-button" onClick={() => {
              navigate(-1);
            }}>
              <FontAwesomeIcon style={{ color: "white" }} icon={faArrowLeft} />
            </div>
          </form>
      }
    </LoginUiComponent>
    }
    </>
  );
}
